module.exports = __webpack_public_path__ + "img/thumbnail_EuropeanBadger_f_albino.ae68b43b.png";